<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="md" ref="biddersModal" :visible="modal.show" :hide-footer="true" :body-class="''"
                   :title="computedTitle" @hidden="onHidden" :show-confirmation="false" scrollable>
      <customer-info-table :customer="object"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import ArtisioModal from "../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import CustomerInfoTable from "../customer/view/dashboard/CustomerInfoTable";

  const {mapState, mapActions} = createNamespacedHelpers('bidders');

  export default {
    name: "BidderInfoModal",
    components: {
      CustomerInfoTable,
      ArtisioModal
    },
    computed: {
      ...mapState({
        modal: state => state.infoModal,
        object: state => state.infoModal.object
      }),
      computedTitle() {
        return this.object ? this.object.display_name : this.$i18n.t('Bidder Info');
      }
    },
    methods: {
      ...mapActions(['hideInfoModal']),
      onHidden() {
        this.hideInfoModal();
      }
    }
  }
</script>

<style scoped>
</style>
